import React from 'react';
import HeroDepthBackground from './HeroDepthBackground';
import PublicLanguageSwitcher from './PublicLanguageSwitcher';
import PublicBackToHomeLink from './PublicBackToHomeLink';

function AuthPageShell({
  children,
  backTo = '/login',
  backLabel,
  showLanguage = true,
  className = '',
}) {
  return (
    <div className={`auth-page dashboard-shell app-shell relative flex min-h-[100dvh] justify-center overflow-x-hidden p-3 safe-x sm:p-4 md:p-6 lg:p-8 max-lg:items-start max-lg:overflow-y-auto lg:items-center lg:overflow-hidden ${className}`}>
      <HeroDepthBackground sceneCount={1} fixed />
      {backLabel ? (
        <PublicBackToHomeLink variant="fixed" label={backLabel} to={backTo} />
      ) : null}
      {showLanguage ? <PublicLanguageSwitcher variant="fixed" /> : null}
      <div className="relative z-10 my-auto w-full">{children}</div>
    </div>
  );
}

export default AuthPageShell;
